export default "__VITE_ASSET__CIVC_PZt__"